import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { map, of } from 'rxjs';

import { BranchDropdownResponseDto, BranchesService } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule } from '@module';

import { BaseDropdown, LibDropdownModule } from 'pn-core-code';

@Component({
  selector: 'shared-branch-dropdown',
  standalone: true,
  imports: [DefaultModule, LibDropdownModule],
  templateUrl: '/node_modules/pn-core-code/src/base/base-dropdown/base-dropdown.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BranchDropdownComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class BranchDropdownComponent extends BaseDropdown<BranchDropdownResponseDto> {
  @Input() type: string | undefined;

  override inputChanges = ['type'];
  override filterBy: string = "branchName"
  override textAttr: string = 'branchName';
  currentLang: string;

  constructor(
    protected override cdr: ChangeDetectorRef,
    protected override translateService: TranslateService,
    private branchesService: BranchesService
  ) {
    super(cdr, translateService);
  }

  override ngOnInit() {

    super.ngOnInit();
  }

  protected override apiOptionListGet$() {
    return this.branchesService.branchesDropdownGet$(1, 999, undefined, this.type);
  }
}
